import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SelectFundingEditFlow from './SelectFundingEditFlow';
import Modal from '../Modal';
import StepByStep from '../StepByStep/StepByStep';
import SelectFundingMethod from '../SelectFundingMethod/SelectFundingMethod';
import FundAmountForm from '../Forms/FundAmountForm';

const steps = [SelectFundingEditFlow, SelectFundingMethod, FundAmountForm];

const FundModal = ({ isOpen, onClose, dataCy }) => {
  const [modalSize, setModalSize] = useState('md');
  const [editFundFlow, setEditFundFlow] = useState('');
  const [eventType, setEventType] = useState(null);
  const formId = 'fundAmount_form';

  return (
    <Modal
      variant={modalSize}
      isOpen={isOpen}
      onClose={onClose}
      dataCy={dataCy}
    >
      <StepByStep saveStepDisabled>
        {({ goStepForward, goStepBack, skipPreviousStep, skipNextStep }) =>
          steps.map((step) =>
            React.createElement(step, {
              handleBack: goStepBack,
              handleNext: goStepForward,
              skipPreviousStep,
              skipNextStep,
              setModalSize,
              setEditFundFlow,
              onModalClose: onClose,
              editFundFlow,
              formId,
              setEventType,
              eventType,
            }),
          )
        }
      </StepByStep>
    </Modal>
  );
};

FundModal.propTypes = {
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  dataCy: PropTypes.string,
};

export default FundModal;
